import
  React, {
  useContext
} from 'react';

import {
  Base,
  VFillContainerH
} from '@vodacom/web-common';

import {
  useAdSlot
} from './useAdSlot';

import {
  Ads,
  FeatureToggles
} from '../../constants';

import {
  AppContext
} from 'context';

import {
  isFeatureEnabled
} from 'helpers';

export const AdSlot = ({ adId, padding = '0', margin = '0px' }) => {
  const { isTransitioning, config } = useContext(AppContext);
  const ad = Ads[adId];

  useAdSlot({
    mapping: ad?.mapping,
    sizes: ad?.sizes,
    id: adId,
    slot: ad?.slot,
    isTransitioning,
    isLoading: !config
  });

  return (
    <>
    {
      isFeatureEnabled(config, FeatureToggles.EnableFuseAds)
        ? <VFillContainerH padding={padding} margin={margin} boxSizing={'border-box'}>
            <Base id={adId} />
          </VFillContainerH>
        : <></>
    }
    </>
  );
};
